import Vue from "vue";
import "./plugins/axios";
import "./plugins/vuetify";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import "./components/filters";
import i18n from "./i18n";
import SVG from "svg.js";

import "./stylus/main.styl";
import "./scss/easyfert.scss";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  SVG,
  render: h => h(App)
}).$mount("#app");
